module.exports = __webpack_public_path__ + "img/arrow5.c41c3682.svg";